export const mockData = [
  {
    product_uuid: '123',
    name: 'Proposal 01',
    sent: '09/03/2021',
    status: 'pending_approval',
  },
];
